import * as jdenticon from "jdenticon";
import React, { useEffect, useRef } from "react";

import { Stack } from "@bps/fluent-ui";

interface IdentityIconProps {
  id: string;
  size?: number;
}

export const IdentityIcon: React.FC<IdentityIconProps> = ({ id, size }) => {
  const icon = useRef(null);
  const iconSize = size ?? 30;

  useEffect(() => {
    jdenticon.update(icon.current!, id);
  }, [id]);

  return (
    <Stack.Item
      styles={{
        root: {
          background: "white",
          border: "1px solid"
        }
      }}
    >
      <svg
        data-jdenticon-value={id}
        height={iconSize}
        ref={icon}
        width={iconSize}
      />
    </Stack.Item>
  );
};
